export class VersionInformation {
    public tag = "v2.0.0-alpha.30";
    public tagDate = "2018-04-05";
    public tagLink = "https://github.com/ultimate-comparisons/ultimate-comparison-BASE/tree/v2.0.0-alpha.30";
}



// WEBPACK FOOTER //
// ./src/assets/VersionInformation.ts